import { render, staticRenderFns } from "./MatterRealizationScopeSelection.vue?vue&type=template&id=aca057d4&scoped=true"
import script from "./MatterRealizationScopeSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./MatterRealizationScopeSelection.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MatterRealizationScopeSelection.vue?vue&type=style&index=0&id=aca057d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca057d4",
  null
  
)

export default component.exports